import { Theme } from "@mui/material";

import makeStyles from "@mui/styles/makeStyles";

export const useStyles = makeStyles((theme: Theme) => ({
  card: {
    backgroundColor: theme.palette.common.white,
    borderRadius: theme.shape.borderRadius,
    border: `1px solid ${theme.palette.grey[200]}`,
    padding: theme.spacing(6),
    boxShadow: "0px 1px 2px rgba(0, 0, 0, 0.05)",
    transition: "box-shadow 0.3s ease",
    "&:hover": {
      boxShadow:
        "0px 4px 6px -1px rgba(0, 0, 0, 0.1), 0px 2px 4px -1px rgba(0, 0, 0, 0.06)",
    },
  },
  iconWrapper: {
    padding: theme.spacing(1),
    borderRadius: theme.spacing(1),
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "fit-content",
  },
  blueIconBg: {
    backgroundColor: "#EFF6FF",
    color: "#2563EB",
  },
  purpleIconBg: {
    backgroundColor: "#FAF5FF",
    color: "#9333EA",
  },
  greenIconBg: {
    backgroundColor: "#F0FDF4",
    color: "#16A34A",
  },
  orangeIconBg: {
    backgroundColor: "#FFF7ED",
    color: "#EA580C",
  },
  flexBetween: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    marginBottom: theme.spacing(3),
  },
  manageLink: {
    display: "block",
    textAlign: "left",
    marginTop: theme.spacing(2),
    color: theme.palette.primary.main,
    fontSize: 13,
    cursor: "pointer",
    textDecoration: "underline",
    background: "none",
    border: "none",
    padding: 0,
    width: "100%",
    "&:hover": {
      opacity: 0.8,
    },
  },
}));
